export default __webpack_public_path__ + "navigation-examples-custom-banner-thumbnail-480-9bfc7827afc5baa1d08509d1676d6cf9.png";